import request from '../requestPB'
import { SERVER_DOMAIN, PROTO_MODULE, STOCK_SERVER_DOMAIN } from '../constant'


// 在获取网页授权access_token时获取openid POST api/v2/cashier/detail
export const fetchCashierDetail = (params) => {
  console.log(params)
  return request({
    url: `${SERVER_DOMAIN}/api/v2/cashier/detail`,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSCashierDetailRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSCashierDetailResponse',
    // ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
  })
}

// 微信code授权
export const fetchOpenId = (params) => {
  return request({
    url: `${SERVER_DOMAIN}/api/v2/cashier/wxAuthByCode`,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.TSWXAuthByCodeRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.TSWXAuthByCodeResponse',
    // ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
  })
}

// 一般浏览器支付
export const commonBrowserRequest = ({url, payType, orderNo, quitUrl} ) => {
  // console.log(params)
  return request({
    url: url,
    method: 'POST',
    data: { payType, orderNo, quitUrl }
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PubOrderPayBrowserRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PubOrderPayBrowserResponse',
    // ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
    ERROR_ACTION: 'toast',
    httpAddress: 'common',
  })
}

// 微信浏览器支付
export const wxBrowserRequest = (params) => {
  return request({
    url: params.url,
    method: 'POST',
    data: params
  }, {
    PB_LOOK_TYPE_PATH_REQUEST: 'proto.PubOrderPayWxBrowserRequest',
    PB_LOOK_TYPE_PATH_RESPONSE: 'proto.PubOrderPayWxBrowserResponse',
    // ERROR_ACTION: 'toast',
    TOKEN_REQUIRED: true,
    ERROR_ACTION: 'toast',
    httpAddress: 'common',
  })
}